
export interface EpisodeFormErrors {
  [key: string]: string;
}

export const validateEpisodeForm = (formData: {
  title?: string;
  category_id?: string;
}): EpisodeFormErrors => {
  const errors: EpisodeFormErrors = {};
  
  if (!formData.title?.trim()) {
    errors.title = "Title is required";
  }
  
  if (!formData.category_id) {
    errors.category_id = "Category is required";
  }
  
  return errors;
};
